// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"212fcfc4","453":"86f7cc51","632":"d1128981"}[chunkId] + ".chunk.js";
};